module.exports = __webpack_public_path__ + "static/media/1.293e1b88.png";